export class DomainError extends Error {
  constructor(message: string) {
    super(message)
    this.name = this.constructor.name
  }
}

export class ValidationError extends DomainError {}

export class VersionMismatchError extends DomainError {
  constructor(expected: number, actual: number) {
    super(`Version mismatch: expected ${expected}, got ${actual}`)
  }
}

export class NotFoundError extends DomainError {
  constructor(entity: string, id: string) {
    super(`${entity} not found: ${id}`)
  }
}

export class ForbiddenError extends DomainError {
  constructor(message = 'Insufficient permissions') {
    super(message)
  }
}

export class ConflictError extends DomainError {
  constructor(message: string) {
    super(message)
  }
}

export class PreconditionFailedError extends DomainError {
  constructor(message: string) {
    super(message)
  }
}
